module.exports = __webpack_public_path__ + "img/terranovaBanner.62a97a8a.png";